// extracted by mini-css-extract-plugin
export var csatScore = "_gc-5";
export var header = "_gc-1";
export var panelWrapper = "_gc-2";
export var postPreview = "_gc-3";
export var rightContent = "_gc-0";
export var wrappingText = "_gc-4";